import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { RechargeComponent } from 'src/app/componentsWallet/components/recharge/recharge.component';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';
import { DebitComponent } from '../debit/debit.component';

@Component({
  selector: 'app-user-actions',
  templateUrl: './user-actions.component.html',
  styleUrls: ['./user-actions.component.scss'],
})
export class UserActionsComponent implements OnInit {
  @Input() user: any;
  @Input() rols: any;
  public staticOptions = [
    // {
    //   text: 'Cambiar Rol',
    //   value: 'Rol'
    // },
    // {
    //   text: 'Cambiar estado',
    //   value: 'Estado'
    // },
    // {
    //   text: 'Cambiar verificacion',
    //   value: 'Verificados'
    // }
  ];
  private _domainId = environment.domainId;
  public formData = undefined;
  public existDistributorSignUpRes = undefined;

  constructor(
    public paramSv: ParamServicesService,
    public modalController: ModalController,
    private uiSv: UiServices,
    private formSv: FormServices,
    private httpSv: HttpService,
    private translateSv: TranslateService
  ) {}

  async ngOnInit() {
    try {
      this.existDistributorSignUpRes = await this.paramSv
        .existDistributorSignUpRes;

      if (this.user.files && this.user.files.length) {
        this.user.files = this.user.files.map((item) => {
          if (item.file.includes('pdf')) {
            item.icon = 'document-outline';
          } else {
            item.icon = 'image-outline';
          }
          return item;
        });
      }
      this.user.isActive
        ? (this.user.isActive = true)
        : (this.user.isActive = false);
      if (this.paramSv.wallet) {
        if (this.paramSv.wallet.value.value === '1') {
          this.staticOptions.push({
            text: 'Transacción',
            value: 'Transacción',
          });
        }
      }
      this.user.isVerify = !this.user.isVerify ? false : true;
      const res = await this.formSv.getForm('userAdmin', this._domainId);
      this.formData = res;
    } catch (err) {
      console.error(err);
    }
  }

  async doAction(ev) {
    let data = ev.detail.value;
    const id = this.user.id;
    const balance = this.user.balance;
    const res = await this.uiSv.showModal(
      RechargeComponent,
      { type: data, id: id, balance },
      'successComponent'
    );
    if (data === 'debit' && res.data) {
      await this.uiSv.showModal(
        DebitComponent,
        { data: res.data },
        'successComponent'
      );
    }
    await this.modalController.dismiss('reload');
  }

  async save(ev: FormData) {
    try {
      ev.set('id', this.user.id);
      await this.uiSv.showLoading();
      await this.httpSv.itemAction(ev, 'admin/user', 'update');
      await this.uiSv.loading.dismiss();
      const translate = this.translateSv.instant('GUARDADO_EXITOSAMENE');
      await this.uiSv.showToast(translate);
      await this.modalController.dismiss('reload');
    } catch (err) {
      console.error(err);
    }
  }
}
